import * as React from 'react';
import { Button } from '../../../web/components-v2/Button';
import {
	Dialog,
	DialogPopup,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogFooter,
} from '../../../web/components-v2/Dialog';
import { FieldError } from '../../../web/components-v2/Field';

export interface ConfirmModalProps {
	title: string;
	message: string;
	confirmLabel?: string;
	cancelLabel?: string;
	onConfirm: () => void;
	onCancel: () => void;
	/** Use 'danger' for destructive actions */
	variant?: 'primary' | 'danger';
	/** A confirm backed by a mutation: locks both buttons and dismissal while the request is in flight. */
	busy?: boolean;
	/** Inline failure text for a confirm backed by a mutation, so the dialog can stay open and be retried. */
	error?: string;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
	title,
	message,
	confirmLabel = 'Confirm',
	cancelLabel = 'Cancel',
	onConfirm,
	onCancel,
	variant = 'primary',
	busy = false,
	error,
}) => {
	return (
		<Dialog
			open
			dismissOnOutsideClick={!busy}
			onOpenChange={open => {
				if (!open && !busy) onCancel();
			}}
		>
			<DialogPopup showCloseButton={!busy}>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>{message}</DialogDescription>
				</DialogHeader>
				{error && <FieldError>{error}</FieldError>}
				<DialogFooter>
					<Button variant='outline' size='sm' onClick={onCancel} disabled={busy}>
						{cancelLabel}
					</Button>
					<Button
						variant={variant === 'danger' ? 'destructive' : 'primary'}
						size='sm'
						onClick={onConfirm}
						disabled={busy}
					>
						{confirmLabel}
					</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};
